/**
 * Client model for Ask Addy follow-up suggestion API.
 */
import GlobalVariables from "./globalVariables";

const BASE_PATH = "/api/ask-addy";
const HEADERS = { "Content-Type": "application/json" };

function getValidSuggestions(data) {
  if (!Array.isArray(data?.suggestions)) {
    return [];
  }

  return data.suggestions.filter(
    (suggestion) =>
      typeof suggestion === "string" && suggestion.trim().length > 0,
  );
}

class AskAddyFollowUpModel {
  static getGenerateFollowUpsURL() {
    return `${GlobalVariables.getAPIURL()}${BASE_PATH}/generate-follow-ups`;
  }

  /**
   * Generate contextual follow-up questions after an Ask Addy answer.
   * Failures return [] so the chat UX is never blocked.
   *
   * @param {object} params
   * @param {string[]} [params.previousQuestions]
   * @param {string} [params.lastUserQuestion]
   * @param {string} [params.lastResponse]
   * @param {string|null} [params.loanId]
   * @param {string|null} [params.memberRole]
   * @returns {Promise<string[]>}
   */
  static async generateFollowUps({
    previousQuestions = [],
    lastUserQuestion = "",
    lastResponse = "",
    loanId = null,
    memberRole = null,
  } = {}) {
    try {
      const response = await fetch(
        AskAddyFollowUpModel.getGenerateFollowUpsURL(),
        {
          method: "POST",
          headers: HEADERS,
          body: JSON.stringify({
            previousQuestions,
            lastUserQuestion,
            lastResponse,
            loanId,
            memberRole,
          }),
        },
      );

      const data = await response.json();

      return getValidSuggestions(data);
    } catch (error) {
      console.warn(
        "[AskAddyFollowUpModel] Failed to generate follow-ups:",
        error?.message || error,
      );

      return [];
    }
  }
}

export default AskAddyFollowUpModel;
